"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pollFooter = exports.pollContent = exports.pollHeader = void 0;

var _emotion = require("emotion");

var _themeConfig = _interopRequireDefault(require("@lyearn-team/theme-config"));

var pollHeader =
/*#__PURE__*/
(0, _emotion.css)("justify-content:space-between;.buttons-wrapper{display:flex;align-content:center;}.delete-poll-button{margin-right:25px;&.disabled{opacity:0.6}}.text-buttons{font-size:14px;font-weight:500;font-stretch:normal;font-style:normal;line-height:1.71;letter-spacing:normal;}");
exports.pollHeader = pollHeader;
var pollContent =
/*#__PURE__*/
(0, _emotion.css)("display:flex;flex-direction:column;flex-grow:1;padding:8px 16px 8px 20px;.IconClose{width:14px;height:14px;fill:", _themeConfig.default.color.dark.silver, ";}");
exports.pollContent = pollContent;
var pollFooter =
/*#__PURE__*/
(0, _emotion.css)("display:flex;justify-content:space-between;align-items:center;flex-wrap:wrap;.footer-switch{justify-content:flex-start;padding:10px 0px;display:flex;min-width:50%;}.footer-buttons{justify-content:flex-end;padding:10px 0px;display:flex;min-width:50%;}.footer-switch .react-toggle--checked .react-toggle-track{background-color:", _themeConfig.default.color.dark.sapphire, ";}.footer-switch .react-toggle--checked:hover:not(.react-toggle--disabled) .react-toggle-track{background-color:", _themeConfig.default.color.dark.sapphire, ";}.primary-button + .primary-button{margin-left:20px;}");
exports.pollFooter = pollFooter;